"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ABILITIES = void 0;
var ABILITIES = {
  MANAGE_USERS: 'manage_users',
  ACCESS_ADMIN_DASHBOARD: 'access_admin_dashboard',
  ACCESS_GIFTER_DASHBOARD: 'access_gifter_dashboard',
  MANAGE_TAGS: 'manage_tags',
  MANAGE_PAYMENTS: 'manage_payments',
  SET_CUSTOM_GIFT_LANGUAGE_TYPE: 'set_custom_gift_language_type',
  DISABLE_GIFT_EXCHANGE_DONATE: 'disable_gift_exchange_donate',
  SEND_ALYCE_GIFT_CARDS: 'send_alyce_gift_cards',
  EXPIRE_CODE: 'expire_code',
  USER_TRANSFER_CREDITS: 'user_transfer_credits',
  USER_CREATE_TEAM: 'user_create_team',
  USE_TEAM_LIMITS: 'use_team_limits',
  MANAGE_QUEUE_WORKER: 'manage_queue_worker',
  MANAGE_APP: 'manage_app',
  CAN_USE_PUBLIC_API: 'can_use_public_api',
  MANAGE_PRODUCTS: 'manage_products',
  USE_AGENTS_APP: 'use_agents_app',
  AGENTS_APP_REVIEW_RESEARCH: 'agents_app_review_research',
  AGENT_APP_USE_EXTENDED_FLAGS: 'agent_app_use_extended_flags',
  MANAGE_GIFTS: 'manage_gifts',
  CAN_CHANGE_ORGANIZATION_FEATURES: 'can_change_organization_features',
  CAN_CHANGE_ORGANIZATION_PACKAGE: 'can_change_organization_package',
  DELETE_GIFTS: 'delete_gifts',
  MANAGE_SETTINGS: 'manage_settings',
  MANAGE_MESSAGES: 'manage_messages',
  EDIT_DB: 'edit_db',
  PROPOSE_PRODUCTS: 'propose_products',
  MANAGE_ADMIN_SETTINGS: 'manage_admin_settings',
  CAN_USE_CHROME_EXTENSION: 'can_use_chrome_extension',
  USE_AUTO_SHORTLIST_PRODUCTS: 'use_auto_shortlist_products',
  CAN_VIEW_BILLING_REPORTS: 'can_view_billing_reports',
  CAN_EDIT_TEAM: 'can_edit_team',
  CHANGE_RESEARCH_PRIORITY: 'change_research_priority',
  ACCESS_SECURITY_FEATURES: 'access_security_features',
  CAN_MODIFY_ROLES: 'can_modify_roles',
  CAN_LOGIN_AS_USER: 'can_login_as_user'
};
exports.ABILITIES = ABILITIES;